<template>
    <v-ons-page>
        <v-ons-toolbar>
          <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
            <slot> {{ this.title }}</slot>
          </div>
        </v-ons-toolbar>
        <ons-list>
            <ons-list-item class="border-solid" tappable @click="push(lang)" v-for="(lang,index) in langs" :key="index">
                <div class=" itemList alingCenter" style="font-size:32px ">
                    {{lang}}
                </div>
                <div class="separator"></div>
            </ons-list-item>
        </ons-list>
    </v-ons-page>
</template>

<script>

    import MenuPage from './MenuPage'
    import TopBar from '../components/TopBar'
    import BottomBar from '../components/BottomBar'
    import constants from '../constants'

    export default {
        name: 'lang',

        data: function () {
            return {
                audios:null,
                title: this.$t("message.title"),
            }
        },

        computed: {
            langs: {
                get () {
                    return this.$store.state.langs.types
                },
            }
        },
        methods: {
            push(lang) {

                //constants.URL_AUDIO+'
                this.$i18n.locale = lang;
                this.$store.commit('langs/toggle', lang)
                this.$emit('push', {
                    extends: MenuPage
                });

                if (window.navigator.onLine ) {
                    var idioma = "";

                    if (lang == "Español") {
                        idioma = "ESP";
                    } else if (lang == "Valencià") {
                        idioma = "VAL";
                    } else if (lang == "Français") {
                        idioma = "FRA";
                    } else if (lang == "English") {
                        idioma = "ENG";
                    } else if (lang == "Deutsch") {
                        idioma = "DEU";
                    } else if (lang == "Italiano") {
                        idioma = "ITA";
                    } else if (lang == "Português") {
                        idioma = "POR";
                    } else if (lang == "Pусский") {
                        idioma = "RUS";
                    } else if (lang == "Nederlands") {
                        idioma = "NED";
                    } else if (lang == "Polski") {
                      idioma = "POL";
                    }

                    caches.keys().then(function (names) {
                        for (let name of names) {
                            if (!name.startsWith("sw")) {
                                caches.delete(name);
                            }
                        }
                        //caches.delete(name);
                    });

                    this.audios = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18'];
                    this.cachingAudios(idioma, 0);
                }




                /*fetch('/audios/CAT/1.mp3')
                    .then(resp => resp.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = 'todo-1.json';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        //alert('your file has downloaded!'); // or you know, something with better UX...
                    })
                    .catch(() => alert('oh no!')
                    );*/






            },
            cachingAudios(idioma,i) {
                if(i==0) alert(this.$t("message.initDownload"));
                if(i<this.audios.length) {
                    fetch('/audios/' + idioma + '/' + this.audios[i] + '.mp3')
                        .then(resp => resp.blob())
                        .then(blob => {
                            if(i==this.audios.length-1){
                                alert(this.$t("message.endDownload"));
                            }
                            this.cachingAudios(idioma,i + 1)
                        });
                }
            }
        },
        components: {
            TopBar,
            BottomBar
        }
    }
</script>
<style lang="css" src="../assets/css/styles.css"/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .centeLangs {
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: center;*/
        /*margin-top: 50%;*/
    }

    .alingCenter {
        width: 100%;
        text-align: center;
        /*font-size: 6.6vw;*/
    }

    .itemList {
        margin: 10% 0%;
    }

    .border-solid {
        /*border-bottom: solid 3px;*/
        padding: 0 10%;
    }


</style>



// WEBPACK FOOTER //
// src/pages/LangPage.vue